var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [(!_vm.isverificationenabled) ? _c('fieldset', [_c('b-card', [_c('h4', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.isverificationenabledMsg))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.isverificationenabled) ? _c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('legend', [_vm._v("AWB Verification (Dim & Wt)")]), _vm._v(" "), _c('b-card', {
    staticStyle: {
      "background-color": "rgb(208, 219, 225)"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("AWB No.")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AWBnumber),
      expression: "AWBnumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "AWBnumber",
    class: {
      'form-control': true, 'error': _vm.errors.has('AWBnumber')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter AWB",
      "name": "AWBnumber",
      "id": "AWBnumber"
    },
    domProps: {
      "value": (_vm.AWBnumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AWBnumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('AWBnumber')),
      expression: "errors.has('AWBnumber')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The AWB field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "common-success",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getAWBVerificationDimWt
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    staticStyle: {
      "font-size": "1.2rem"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "common-success",
    staticStyle: {
      "width": "100%"
    },
    style: ((_vm.awbvst == 'Completed' || _vm.isdisable) ? 'opacity: 0.8; cursor: not-allowed;' : ''),
    attrs: {
      "type": "submit",
      "disabled": (_vm.awbvst == 'Completed' || _vm.isdisable) ? true : false
    }
  }, [_vm._v("Mark verification completed")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("Total boxes: " + _vm._s(_vm.totbx))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("Picked physical weight (kg): " + _vm._s(_vm.ppw))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("Picked volumetric weight (kg): " + _vm._s(_vm.pvw))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("AWB verification status: " + _vm._s(_vm.awbvst))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("Verified physical weight (kg): " + _vm._s(_vm.vpw))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("Verified volumetric weight (kg): " + _vm._s(_vm.vvw))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("AWB verification done by: " + _vm._s(_vm.awbvdby))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    style: (_vm.pwd < 0 ? 'color:red;' : _vm.pwd > 0 ? 'color:green;' : '')
  }, [_vm._v("Physical weight difference (kg): " + _vm._s(_vm.pwd)), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v("(Verified - Picked)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    style: (_vm.vwd < 0 ? 'color:red;' : _vm.vwd > 0 ? 'color:green;' : '')
  }, [_vm._v("Volumetric weight difference (kg): " + _vm._s(_vm.vwd)), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v("(Verified - Picked)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("AWB verification done at: " + _vm._s(_vm.awbvdat))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("AWB verification Date and Time: " + _vm._s(_vm.awbvdt))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("AWB verification method: " + _vm._s(_vm.inScanMethod))])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin": "0px 0px 0px 0px"
    }
  }, [_c('div', {
    staticClass: "card-body1 col-md-4",
    staticStyle: {
      "margin-bottom": "0rem",
      "padding": "0px",
      "background-color": "white"
    }
  }, [_vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button', {
        active: _vm.currentTab === tab.key
      }],
      style: (("" + ((_vm.tabs.length==1) ? 'width: 100%;' : (_vm.verificationMethod=='dws') ? 'opacity: 0.8; cursor: not-allowed;' : ''))),
      attrs: {
        "disabled": (_vm.verificationMethod == 'dws') ? true : false,
        "id": tab.value
      },
      on: {
        "click": function($event) {
          _vm.currentTab = tab.key;
          _vm.secondFunction()
        }
      }
    }, [_vm._v("\n              " + _vm._s(tab.value) + "\n            ")])
  }), _vm._v(" "), _c('keep-alive', [_c(_vm.currentTabComponent, {
    key: _vm.componentKey,
    tag: "component",
    staticClass: "tab"
  })], 1)], 2), _vm._v(" "), (_vm.pvSKUError || _vm.empSKUError) ? _c('div', {
    staticClass: "card-body1 col-md-5",
    staticStyle: {
      "margin-left": "1%",
      "color": "red",
      "background-color": "#ff00000a",
      "border-radius": "5px",
      "padding": "8px"
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-exclamation-circle",
    staticStyle: {
      "color": "red"
    }
  }), _vm._v("  " + _vm._s(_vm.pvSKUError || _vm.empSKUError))])]) : _vm._e()]), _vm._v(" "), _c('fieldset', [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "border": "0px",
      "margin-bottom": "0rem"
    }
  }, [(_vm.currentTab == 'manual') ? _c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('button', {
    staticClass: "common-secondary",
    style: ((_vm.inputs.IsMeasurementFlag || Object.keys(_vm.inputs).length <= 0) ? 'opacity: 0.8; cursor: not-allowed;' : ''),
    attrs: {
      "type": "submit",
      "disabled": (_vm.inputs.IsMeasurementFlag || Object.keys(_vm.inputs).length <= 0) ? true : false
    },
    on: {
      "click": _vm.addBox
    }
  }, [_vm._v("Add box")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    style: ((_vm.inputs.IsMeasurementFlag || _vm.remArr.length <= 0) ? 'opacity: 0.8; cursor: not-allowed; width: 14%;' : 'width: 14%;'),
    attrs: {
      "type": "button",
      "disabled": (_vm.inputs.IsMeasurementFlag || _vm.remArr.length <= 0) ? true : false
    },
    on: {
      "click": _vm.removeBoxes
    }
  }, [_vm._v("Remove box(es)")])]) : _c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('span', [_c('b', [_vm._v("Measured: " + _vm._s(_vm.mCount) + " ")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "8%"
    }
  }, [_c('b', [_vm._v("Pending: " + _vm._s(_vm.pCount) + " ")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "16px",
      "float": "right"
    },
    on: {
      "click": function($event) {
        return _vm.getAWBMPSDWSList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload This MPS List"
    }
  })])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [(_vm.currentTab == 'manual') ? _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Select")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Flag")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("S.No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Dimensions L B H (in cm)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Number of boxes")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Physical weight per box (kg)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Total physical weight (kg)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Volumetric weight per box (kg)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Total volumetric weight (kg)")])]) : _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("MPS ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Dimensions L B H (in cm)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Physical Weight (kg)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Volumetric Weight (kg)")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.inputs.SKUDetails), function(input, k) {
    return (_vm.currentTab == 'manual' && _vm.inputs.SKUDetails) ? _c('tr', {
      key: k
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.remArr),
        expression: "remArr"
      }],
      staticClass: "form-control",
      style: ((_vm.inputs.IsMeasurementFlag || input.wtinscan.toLowerCase() == 'dws') ? 'opacity: 0.8; cursor: not-allowed;' : ''),
      attrs: {
        "type": "checkbox",
        "disabled": (_vm.inputs.IsMeasurementFlag || input.wtinscan.toLowerCase() == 'dws') ? true : false
      },
      domProps: {
        "value": k,
        "checked": Array.isArray(_vm.remArr) ? _vm._i(_vm.remArr, k) > -1 : (_vm.remArr)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.remArr,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = k,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.remArr = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.remArr = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.remArr = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(input.wtinscan))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(input.serial))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.PackageDetails.Dimensions.Length),
        expression: "input.PackageDetails.Dimensions.Length"
      }],
      staticClass: "form-controltbl",
      style: ((_vm.inputs.IsMeasurementFlag || input.wtinscan.toLowerCase() == 'dws') ? 'opacity: 0.8; cursor: not-allowed;' : !input.PackageDetails.Dimensions.Length ? 'border-color: red;' : ''),
      attrs: {
        "type": "text",
        "id": ("l" + k),
        "disabled": (_vm.inputs.IsMeasurementFlag || input.wtinscan.toLowerCase() == 'dws') ? true : false,
        "onkeypress": "return event.charCode >= 46 && event.charCode <= 57"
      },
      domProps: {
        "value": (input.PackageDetails.Dimensions.Length)
      },
      on: {
        "change": function($event) {
          return _vm.boxWeightCalc(k)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input.PackageDetails.Dimensions, "Length", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.PackageDetails.Dimensions.Width),
        expression: "input.PackageDetails.Dimensions.Width"
      }],
      staticClass: "form-controltbl",
      style: ((_vm.inputs.IsMeasurementFlag || input.wtinscan.toLowerCase() == 'dws') ? 'opacity: 0.8; cursor: not-allowed;' : !input.PackageDetails.Dimensions.Width ? 'border-color: red;' : ''),
      attrs: {
        "type": "text",
        "id": ("b" + k),
        "disabled": (_vm.inputs.IsMeasurementFlag || input.wtinscan.toLowerCase() == 'dws') ? true : false,
        "onkeypress": "return event.charCode >= 46 && event.charCode <= 57"
      },
      domProps: {
        "value": (input.PackageDetails.Dimensions.Width)
      },
      on: {
        "change": function($event) {
          return _vm.boxWeightCalc(k)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input.PackageDetails.Dimensions, "Width", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.PackageDetails.Dimensions.Height),
        expression: "input.PackageDetails.Dimensions.Height"
      }],
      staticClass: "form-controltbl",
      style: ((_vm.inputs.IsMeasurementFlag || input.wtinscan.toLowerCase() == 'dws') ? 'opacity: 0.8; cursor: not-allowed;' : !input.PackageDetails.Dimensions.Height ? 'border-color: red;' : ''),
      attrs: {
        "type": "text",
        "id": ("h" + k),
        "disabled": (_vm.inputs.IsMeasurementFlag || input.wtinscan.toLowerCase() == 'dws') ? true : false,
        "onkeypress": "return event.charCode >= 46 && event.charCode <= 57"
      },
      domProps: {
        "value": (input.PackageDetails.Dimensions.Height)
      },
      on: {
        "change": function($event) {
          return _vm.boxWeightCalc(k)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input.PackageDetails.Dimensions, "Height", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.NoOfBoxes),
        expression: "input.NoOfBoxes"
      }],
      staticClass: "form-controltbl",
      style: ((_vm.inputs.IsMeasurementFlag || input.UniqueReferenceNumber || input.pvReset) ? 'opacity: 0.8; cursor: not-allowed;' : ''),
      attrs: {
        "type": "text",
        "id": ("bx" + k),
        "disabled": (_vm.inputs.IsMeasurementFlag || input.UniqueReferenceNumber || input.pvReset) ? true : false,
        "onkeypress": "return event.charCode >= 48 && event.charCode <= 57"
      },
      domProps: {
        "value": (input.NoOfBoxes)
      },
      on: {
        "change": function($event) {
          return _vm.boxWeightCalc(k)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input, "NoOfBoxes", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.PackageDetails.Weight.PhyWeight),
        expression: "input.PackageDetails.Weight.PhyWeight"
      }],
      staticClass: "form-controltbl",
      style: ((_vm.inputs.IsMeasurementFlag || input.wtinscan.toLowerCase() == 'dws') ? 'opacity: 0.8; cursor: not-allowed;' : !input.PackageDetails.Weight.PhyWeight ? 'border-color: red;' : ''),
      attrs: {
        "type": "text",
        "id": ("pw" + k),
        "disabled": (_vm.inputs.IsMeasurementFlag || input.wtinscan.toLowerCase() == 'dws') ? true : false,
        "onkeypress": "return event.charCode >= 46 && event.charCode <= 57"
      },
      domProps: {
        "value": (input.PackageDetails.Weight.PhyWeight)
      },
      on: {
        "change": function($event) {
          return _vm.boxWeightCalc(k, 'phy')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input.PackageDetails.Weight, "PhyWeight", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.totPWeight),
        expression: "input.totPWeight"
      }],
      staticClass: "form-controltbl",
      staticStyle: {
        "opacity": "0.8",
        "cursor": "not-allowed"
      },
      attrs: {
        "type": "text",
        "disabled": "",
        "id": ("topw" + k)
      },
      domProps: {
        "value": (input.totPWeight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input, "totPWeight", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.PackageDetails.Weight.VolWeight),
        expression: "input.PackageDetails.Weight.VolWeight"
      }],
      staticClass: "form-controltbl",
      staticStyle: {
        "opacity": "0.8",
        "cursor": "not-allowed"
      },
      attrs: {
        "type": "text",
        "disabled": "",
        "id": ("vw" + k)
      },
      domProps: {
        "value": (input.PackageDetails.Weight.VolWeight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input.PackageDetails.Weight, "VolWeight", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.totVWeight),
        expression: "input.totVWeight"
      }],
      staticClass: "form-controltbl",
      staticStyle: {
        "opacity": "0.8",
        "cursor": "not-allowed"
      },
      attrs: {
        "type": "text",
        "disabled": "",
        "id": ("tovpw" + k)
      },
      domProps: {
        "value": (input.totVWeight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input, "totVWeight", $event.target.value)
        }
      }
    })])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.inputs.MPSDetails), function(input, k) {
    return (_vm.currentTab == 'dws' && _vm.inputs.MPSDetails) ? _c('tr', {
      key: k,
      staticClass: "text-center table-hover"
    }, [(input.MPSInScanFromDevice.toLowerCase() == 'manual') ? _c('td', {
      staticClass: "table-light"
    }, [_vm._v("\n                    " + _vm._s(input.MPSno) + "\n                  ")]) : _c('td', {
      staticClass: "table-secondary"
    }, [_vm._v("\n                    " + _vm._s(input.MPSno) + "\n                  ")]), _vm._v(" "), (input.MPSInScanFromDevice.toLowerCase() == 'manual') ? _c('td', {
      staticClass: "table-light"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.Length),
        expression: "input.Length"
      }],
      staticClass: "form-controltbl",
      attrs: {
        "type": "text",
        "onkeypress": "return event.charCode >= 46 && event.charCode <= 57"
      },
      domProps: {
        "value": (input.Length)
      },
      on: {
        "change": function($event) {
          return _vm.volwtDwsCalc(k)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input, "Length", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.Width),
        expression: "input.Width"
      }],
      staticClass: "form-controltbl",
      attrs: {
        "type": "text",
        "onkeypress": "return event.charCode >= 46 && event.charCode <= 57"
      },
      domProps: {
        "value": (input.Width)
      },
      on: {
        "change": function($event) {
          return _vm.volwtDwsCalc(k)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input, "Width", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.Height),
        expression: "input.Height"
      }],
      staticClass: "form-controltbl",
      attrs: {
        "type": "text",
        "onkeypress": "return event.charCode >= 46 && event.charCode <= 57"
      },
      domProps: {
        "value": (input.Height)
      },
      on: {
        "change": function($event) {
          return _vm.volwtDwsCalc(k)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input, "Height", $event.target.value)
        }
      }
    })]) : _c('td', {
      staticClass: "table-secondary"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.Length),
        expression: "input.Length"
      }],
      staticClass: "form-controltbl",
      staticStyle: {
        "opacity": "0.8",
        "cursor": "not-allowed"
      },
      attrs: {
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": (input.Length)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input, "Length", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.Width),
        expression: "input.Width"
      }],
      staticClass: "form-controltbl",
      staticStyle: {
        "opacity": "0.8",
        "cursor": "not-allowed"
      },
      attrs: {
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": (input.Width)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input, "Width", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.Height),
        expression: "input.Height"
      }],
      staticClass: "form-controltbl",
      staticStyle: {
        "opacity": "0.8",
        "cursor": "not-allowed"
      },
      attrs: {
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": (input.Height)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input, "Height", $event.target.value)
        }
      }
    })]), _vm._v(" "), (input.MPSInScanFromDevice.toLowerCase() == 'manual') ? _c('td', {
      staticClass: "table-light"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.PhyWeight),
        expression: "input.PhyWeight"
      }],
      staticClass: "form-controltbl",
      attrs: {
        "type": "text",
        "onkeypress": "return event.charCode >= 46 && event.charCode <= 57"
      },
      domProps: {
        "value": (input.PhyWeight)
      },
      on: {
        "change": function($event) {
          return _vm.phywtDwsCalc(k)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input, "PhyWeight", $event.target.value)
        }
      }
    })]) : _c('td', {
      staticClass: "table-secondary"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.PhyWeight),
        expression: "input.PhyWeight"
      }],
      staticClass: "form-controltbl",
      staticStyle: {
        "opacity": "0.8",
        "cursor": "not-allowed"
      },
      attrs: {
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": (input.PhyWeight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input, "PhyWeight", $event.target.value)
        }
      }
    })]), _vm._v(" "), (input.MPSInScanFromDevice.toLowerCase() == 'manual') ? _c('td', {
      staticClass: "table-light"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.VolWeight),
        expression: "input.VolWeight"
      }],
      staticClass: "form-controltbl",
      staticStyle: {
        "opacity": "0.8",
        "cursor": "not-allowed"
      },
      attrs: {
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": (input.VolWeight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input, "VolWeight", $event.target.value)
        }
      }
    })]) : _c('td', {
      staticClass: "table-secondary"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.VolWeight),
        expression: "input.VolWeight"
      }],
      staticClass: "form-controltbl",
      staticStyle: {
        "opacity": "0.8",
        "cursor": "not-allowed"
      },
      attrs: {
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": (input.VolWeight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input, "VolWeight", $event.target.value)
        }
      }
    })])]) : _vm._e()
  }), _vm._v(" "), ((Object.keys(_vm.inputs).length <= 0)) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": (_vm.currentTab == 'manual') ? 7 : 4
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])], 1)], 1)])]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.addmodalShow = false
      }
    },
    model: {
      value: (_vm.addmodalShow),
      callback: function($$v) {
        _vm.addmodalShow = $$v
      },
      expression: "addmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.confmsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [((_vm.awbvst == 'Pending' && _vm.pvRatioCounter > 1 && _vm.pvSKUSerial)) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openPVRatioModal
    }
  }, [_vm._v("Confirm")]) : _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.takeAction
    }
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.dwsModalShow = false
      }
    },
    model: {
      value: (_vm.dwsModalShow),
      callback: function($$v) {
        _vm.dwsModalShow = $$v
      },
      expression: "dwsModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Message")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Few MPS scanned via DWS. Please verify using DWS method only.")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [_vm.getAWBMPSDWSList, function($event) {
        _vm.dwsModalShow = false
      }]
    }
  }, [_vm._v("OK")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "centered": "",
      "hide-footer": "",
      "modal-class": "pv-ratio-modal",
      "size": "md"
    },
    model: {
      value: (_vm.pvRatioShow),
      callback: function($$v) {
        _vm.pvRatioShow = $$v
      },
      expression: "pvRatioShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "text-center p-3"
  }, [_c('div', {
    staticClass: "warning-icon mb-3"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  })]), _vm._v(" "), _c('h5', {
    staticClass: "font-weight-bold mb-2"
  }, [_vm._v("P/V Ratio Verification Failed")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted mb-4"
  }, [_c('b', [_vm._v("P/V ratio for SKU (S.No. " + _vm._s(_vm.pvSKUSerial) + ") verification again failed!")]), _vm._v(" "), _c('br'), _vm._v("\n          Do you want to proceed with the entered values?\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "common",
    staticStyle: {
      "margin-right": "2%",
      "width": "30%"
    },
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function($event) {
        _vm.pvRatioShow = false
      }
    }
  }, [_vm._v("Re-enter")]), _vm._v(" "), _c('b-button', {
    staticClass: "common-success",
    staticStyle: {
      "width": "30%"
    },
    on: {
      "click": _vm.takeAction
    }
  }, [_vm._v("Proceed")])], 1)])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29804901","hasScoped":true}!./src/views/components/AWBVerificationDimWt_v1/AWBVerificationDimWt_v1.component.html
// module id = 1745
// module chunks = 2